import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.create";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ChildWindow from 'wfui-digital-core/es/ChildWindow';
import Dialog from 'wfui-digital-core/es/Dialog';
import { hideConfirmation } from '../../lib/store/navigation/actions';
import getConfirmationContent from './content/get-confirmation-content';

var LeaveWellsFargoConfirmationModal = /*#__PURE__*/function (_React$Component) {
  _inherits(LeaveWellsFargoConfirmationModal, _React$Component);

  var _super = _createSuper(LeaveWellsFargoConfirmationModal);

  function LeaveWellsFargoConfirmationModal() {
    var _this;

    _classCallCheck(this, LeaveWellsFargoConfirmationModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onAccept", function () {
      _this.props.closeModal();

      _this.props.navigation.confirmResolve();
    });

    _defineProperty(_assertThisInitialized(_this), "onDecline", function () {
      _this.props.closeModal();

      _this.props.navigation.confirmReject();
    });

    _defineProperty(_assertThisInitialized(_this), "onFrameworkClose", function () {
      _this.props.navigation.confirmReject();

      _this.props.closeModal();
    });

    return _this;
  }

  _createClass(LeaveWellsFargoConfirmationModal, [{
    key: "render",
    value: function render() {
      var navigation = this.props.navigation;
      var showConfirmation = navigation.showConfirmation,
          confirmationType = navigation.confirmationType;
      var Content = getConfirmationContent(confirmationType);
      return /*#__PURE__*/React.createElement(Dialog, {
        isOpen: showConfirmation,
        onFrameworkClose: this.onFrameworkClose
      }, /*#__PURE__*/React.createElement(Content, {
        onAccept: this.onAccept,
        onDecline: this.onDecline,
        navigation: navigation
      }));
    }
  }]);

  return LeaveWellsFargoConfirmationModal;
}(React.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var core = _ref.core;
  return {
    navigation: core.navigation
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeModal: function closeModal() {
      return dispatch(hideConfirmation());
    }
  };
};

var wrappedModal = withRouter(ChildWindow(LeaveWellsFargoConfirmationModal));
export default connect(mapStateToProps, mapDispatchToProps)(wrappedModal);